export const TABLE_RECENTLY_CLOSED_POSITIONS = [];
